export default "__VITE_ASSET__lwOK6S$N__"